// Friendly error panel for visitors. The technical message (server address, HTTP status) goes to the console only,
// except on the private preview pages (`technical`), where the editor needs it.
const COPY = {
  offline: {
    title: 'Articles are temporarily unavailable',
    text: 'We could not load our articles right now. This is on our side, not yours. Please try again in a few minutes.',
  },
  server: {
    title: 'Something went wrong on our side',
    text: 'Our content service had a problem while loading this. Please try again shortly.',
  },
  config: {
    title: 'Articles are not available yet',
    text: 'This section is still being set up. Please check back soon.',
  },
};

export default function LoadError({ error, onRetry, technical = false, what = 'articles' }) {
  const copy = COPY[error?.kind] || COPY.server;
  return (
    <div className="status-message" role="alert">
      <h2>{copy.title}</h2>
      <p>{copy.text.replace('articles', what)}</p>
      {technical && error?.message && <p className="field-hint">Details: {error.message}</p>}
      {onRetry && (
        <p>
          <button type="button" className="btn btn-primary" onClick={onRetry}>Try again</button>
        </p>
      )}
    </div>
  );
}
